export enum CustomViewType {
  HOTEL = "hotel"
}
